/**
 * Created by bjarne on 2017-03-24.
 */
module com.quickspin.module.api {

	import IModuleServices = com.quickspin.module.api.IModuleServices;

	export interface IModuleBootstrap {

		bootUp(manager:IModuleServices):void;

		setService(id:string, service:any):void;
	}
}